import { combineReducers } from "redux";
import investors from "./viewInvestors/Reducers";



const reducers = combineReducers({
    investors,
   
});
export default reducers;
